/* eslint-disable no-param-reassign */
import React, { useEffect } from "react";
import {
    Button, Select, Dropdown, Menu, Modal, message, notification
} from "antd";
import {
    DownOutlined, DownloadOutlined, SaveOutlined, EditOutlined,
    ExclamationCircleOutlined, PlusOutlined, CloseOutlined, PlusSquareOutlined, LoadingOutlined
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { MdOutlineWysiwyg } from "react-icons/md";
import { RiFileCopy2Fill, RiFolderChartLine } from "react-icons/ri";
import { setFreeFormTypeToAdd, setFullMarketTypeToAdd, setMarketCategoryTypeToAdd, setQuickReportTypeToAdd, setTileSelected, setVisibleAddAudienceModal } from "../../../store/components/Reports.slice";
import { setCurrentSelectedMode, setReportBuilderMode } from "../../../store/components/ReportBuilder.slice";
import { fDownloadReportCSV, getAvailableAnalysis, getMarketPackageCode, getModuleCode, getSelectedAnalysis } from "../../../utils/oneintelligence/OneIntelligenceHelper";
import { setEditTarget, setScrapeViewer } from "../../../store/components/BuildTargets.slice";
import { isHasScrapeTopicBrandPermission } from "../../../utils/MainHelper";
import { getAnalysisName } from "../../../utils/analysis/AnalysisHelper";

const { Option } = Select;
function ReportBuilderResultHeader({
    setBehaviouralSegmentData,
    setShowWhitespacesSelection,
    setShowAddBehaviouralSegment,
    setShowFreeForm,
    setshowQuickReport,
    setShowPublishAnalysis,
    setShowSaveAnalysis,
    setShowLoadReport
}) {
    const dispatch = useDispatch();

    const marketPackageCode = getMarketPackageCode();
    const {
        reportIsLoading,
        tilesSelected,
        lowerLevelPerGroup,
        categoryDeepDiveData,
        selectedInterestLevel
    } = useSelector((state) => state.reports);

    const { mode } = useSelector((state) => state.reportBuilder);
    const {
        countryNotAvailable,
        scrapeViewer
    } = useSelector((state) => state.buildTargets);


    const allTileSelected = Object.values(tilesSelected).reduce((acc, item) => {
        acc = acc.concat(item);
        return acc;
    }, []);

    const generatingData = !!Object.values(lowerLevelPerGroup).find((d) => d.loading);
    useEffect(() => {
        if (Object.keys(lowerLevelPerGroup).length && categoryDeepDiveData.length && Object.keys(lowerLevelPerGroup).length === categoryDeepDiveData.length) {
            const moduleCode = getModuleCode()
            if (["globalwebindex", "customerbehavior"].includes(moduleCode)) {
                if (!generatingData) {
                    notification.success({
                        message: "",
                        description: "Download CSV is now ready.",
                        placement: "topRight",
                    });
                }
            }
        }
    }, [categoryDeepDiveData, lowerLevelPerGroup, generatingData])

    const actionList = [
        {
            label: "Save Dashboard",
            key: "saveanalysis",
            icon: <SaveOutlined />
        },
        {
            label: "Load Dashboard",
            key: "loadanalysis",
            icon: <RiFolderChartLine />
        },
        {
            label: "New Dashboard",
            key: "newanalysis",
            icon: <MdOutlineWysiwyg />
        },
        {
            label: "Publish Dashboard",
            key: "publishdashboard",
            icon: <SaveOutlined />
        },
        {
            label: generatingData ? "Generating Data for CSV..." : "Download as CSV",
            key: "downloadcsv",
            icon: generatingData ? <LoadingOutlined /> : <DownloadOutlined />,
            disabled: generatingData
        }
    ];

    const actionItems = {
        onClick: (e) => {
            switch (e.key) {
                case "downloadcsv": {
                    fDownloadReportCSV();
                    break;
                }
                case "saveanalysis": {
                    setShowSaveAnalysis(true);
                    break;
                }
                case "loadanalysis": {
                    Modal.confirm({
                        title: "Load Dashboard",
                        icon: <ExclamationCircleOutlined />,
                        content: "Loading new dashboard will update your current dashboard. Do you want to continue?",
                        okText: "Load",
                        cancelText: "Cancel",
                        onOk: () => {
                            setShowLoadReport(true);
                        }
                    });
                    break;
                }
                case "newanalysis": {
                    dispatch(setEditTarget(true));
                    break;
                }
                case "publishdashboard": {
                    setShowPublishAnalysis(true);
                    break;
                }
                default:
            }
        },
        items: actionList.filter((actionItem) => {
            if (getMarketPackageCode()
                === "whitespaces" && ["saveanalysis", "publishdashboard"].includes(actionItem.key)) {
                return null;
            }
            return actionItem
        })
    }

    const confirm = (e) => {
        Modal.confirm({
            title: "Confirm",
            icon: <ExclamationCircleOutlined />,
            content: "The existing report will be removed. Are you sure you want to continue?",
            okText: "Yes",
            cancelText: "Cancel",
            onOk: async () => {
                await dispatch(setCurrentSelectedMode(e))
                if (e === "singlecategory") {
                    dispatch(setQuickReportTypeToAdd("new"));
                    setshowQuickReport(true);
                } else if (["marketcategory", "hcpattributes",
                    "yahoo_audiences_attribute_targeting",
                    "yahoo_audiences_interests",
                    "yahoo_audiences_purchase_intent_targeting",
                    "hcpmarketscan",
                    "petientmarketscan", "analysis_gdn&trv_affinity",
                    "analysis_gdn&trv_purchase",
                    "analysis_gdn&trv_topic",
                    "tiktokhastags",
                    "tiktokinterest",
                    "tiktokvideointeractions",
                    "purchaseintentions",
                    "icd10clinicalmodification",
                    "icd10procedurecodingsystem",
                    "tiktokcreatorinteractions",
                    "la_demographicsattributes",
                    "la_behavioralattributes",
                    "la_purchaseintent",
                    "la_hobbiesinterests",
                    "medicaljournal",
                    "medicalassociations",
                    "medicalwebsites",
                    "medicalconferences",
                    "mokb_analysis",
                    "continuingmedicaleducation"
                ].includes(e)) {
                    if (marketPackageCode === "whitespaces" && "mokb_analysis" === type.key) {
                        setShowWhitespacesSelection({
                            show: true,
                            isInclude: false,
                            analysis: type.key
                        });
                    } else {
                        dispatch(setMarketCategoryTypeToAdd("new"));
                        setShowAddBehaviouralSegment(true);
                    }
                } else if (["candidatewhitespaces",
                    "analysis_politicaltaxonomy",
                    "usersearchjourney",
                    "otherwhitespaces",
                    "claimswhitespaces",
                    "ingredientshitespaces",
                    "safetycocernsideeffectswhitespaces",
                    "macrowhitespaces",
                    "othermacrowhitespaces",
                    "standardtreatmentjourney",
                    "symptomswhitespaces",
                    "diagnosistreatmentwhitespaces"].includes(e)) {
                    let isInclude = true;
                    if (e === "otherwhitespaces" || e === "othermacrowhitespaces") {
                        isInclude = false;
                    }
                    setShowWhitespacesSelection({
                        show: true,
                        isInclude,
                        analysis: e
                    });
                } else if (e === "freeform") {
                    dispatch(setFreeFormTypeToAdd("new"));
                    setShowFreeForm(true);
                } else {
                    dispatch(setFullMarketTypeToAdd("new"));
                    dispatch(setReportBuilderMode(e));
                }
            }
        });
    };

    const moduleCode = getModuleCode()

    const renderScrapeBtn = (
        <>
            {
                !scrapeViewer ? <div className="d-flex justify-content-end" style={{ width: "100%", padding: "2mm 4mm" }}>
                    {
                        isHasScrapeTopicBrandPermission() ? <Button
                            icon={<PlusSquareOutlined />}
                            type="link"
                            onClick={() => {
                                // dispatch(setScrapeViewer(true))
                                window.open("https://oneknowledge.sqreemtech.com/")
                            }}
                            disabled={reportIsLoading}
                        >
                            Add New to My Own Knowledge Base
                        </Button> : null
                    }
                </div> : null
            }
        </>

    )

    const getHeader = () => {
        if (mode === "select") return renderScrapeBtn;
        const isMediaPlanning = moduleCode.includes("mediaplanning") || moduleCode.includes("b2b");
        return (
            <div className="d-flex justify-content-between" style={{ width: "100%", padding: "2mm 4mm" }}>
                <Select
                    style={{ color: "var(--blue-600)" }}
                    bordered={false}
                    value={mode}
                    disabled={reportIsLoading || countryNotAvailable || scrapeViewer}
                    onChange={(e) => {
                        confirm(e);
                    }}
                >
                    {getAvailableAnalysis()
                        .map((analysis) => (
                            <Option
                                value={analysis.key}
                                key={analysis.key}
                                disabled={analysis.notAvailable}
                            >
                                {getAnalysisName(analysis, moduleCode)}
                            </Option>
                        ))}
                </Select>
                <div className="d-flex gap-1">
                    {(isMediaPlanning && allTileSelected.length) ? (
                        <>
                            <span style={{
                                padding: "1mm 3mm",
                                background: "#DBEAFE",
                                borderRadius: "5px",
                                color: "#3B82F6"
                            }}
                            >
                                {`${allTileSelected.length} Selected`}
                            </span>
                            <Button
                                disabled={scrapeViewer}
                                type="text"
                                danger
                                onClick={() => {
                                    dispatch(setTileSelected({ removeAll: true }));
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: "13px"
                                    }}
                                >
                                    <CloseOutlined style={{
                                        fontSize: "11px",
                                        marginRight: "1mm"
                                    }}
                                    />
                                    Remove All Selected
                                </div>
                            </Button>
                            <Button
                                disabled={scrapeViewer}
                                type="primary"
                                onClick={() => {
                                    if (["fullmarket",
                                        "singlecategory"].includes(mode)) {
                                        message.warning(`Creating audience in ${getSelectedAnalysis(mode).title} is not yet supported.`);
                                        return;
                                    }
                                    let toAddAudience = allTileSelected.filter(({ behaviormatch }) => !selectedInterestLevel.includes(behaviormatch))

                                    if (mode !== "freeform") {
                                        let countOfKeywords = 0
                                        const allValid = toAddAudience.filter((d) => {
                                            if (!(d.children || d.tempChildren)) {
                                                countOfKeywords += 1
                                                return false
                                            }
                                            return d
                                        });

                                        if (!allValid.length) {
                                            message.warning("All selected items are keywords. Please go up a level and select a folder instead.");
                                            return
                                        }
                                        // if (countOfKeywords) {
                                        //     message.info(`(${countOfKeywords}) keyword(s) will not be added in behavior list.`);
                                        //     debugger
                                        // }
                                        toAddAudience = allValid
                                    }

                                    dispatch(setVisibleAddAudienceModal({
                                        visible: true,
                                        trackKey: "advanceCreatePackage",
                                        toAddNewAudience: toAddAudience,
                                        toAddNewAudienceName: "",
                                    }));
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: "13px"
                                    }}
                                >
                                    <PlusOutlined style={{
                                        fontSize: "11px",
                                        marginRight: "1mm"
                                    }}
                                    />
                                    Add to Audience
                                </div>
                            </Button>
                        </>
                    ) : (
                        <>
                            {(["marketcategory", "hcpattributes", "hcpmarketscan", "petientmarketscan", "analysis_gdn&trv_affinity",
                                "analysis_gdn&trv_purchase",
                                "analysis_gdn&trv_topic",
                                "yahoo_audiences_attribute_targeting",
                                "yahoo_audiences_interests",
                                "yahoo_audiences_purchase_intent_targeting",
                                "tiktokhastags",
                                "tiktokinterest",
                                "icd10clinicalmodification",
                                "icd10procedurecodingsystem",
                                "tiktokvideointeractions",
                                "purchaseintentions",
                                "tiktokcreatorinteractions",
                                "la_demographicsattributes",
                                "la_behavioralattributes",
                                "la_purchaseintent",
                                "la_hobbiesinterests",
                                "medicaljournal",
                                "medicalassociations",
                                "medicalwebsites",
                                "medicalconferences",
                                "continuingmedicaleducation"].includes(mode) || (marketPackageCode !== "whitespaces" && "mokb_analysis" === mode)) && (
                                    <Button
                                        icon={<EditOutlined />}
                                        onClick={() => {
                                            dispatch(setCurrentSelectedMode("marketcategory"))
                                            dispatch(setMarketCategoryTypeToAdd("add"));
                                            setBehaviouralSegmentData(null);
                                            setShowAddBehaviouralSegment(true);
                                        }}
                                        disabled={reportIsLoading || countryNotAvailable || scrapeViewer}
                                    >
                                        Change Category
                                    </Button>
                                )}
                            {["hcpattributes"].includes(mode) && (
                                <Button
                                    icon={<EditOutlined />}
                                    onClick={() => {
                                        dispatch(setCurrentSelectedMode("hcpattributes"))
                                        dispatch(setMarketCategoryTypeToAdd("add"));
                                        setBehaviouralSegmentData(null);
                                        setShowAddBehaviouralSegment(true);
                                    }}
                                    disabled={reportIsLoading || countryNotAvailable || scrapeViewer}
                                >
                                    Change Attribute
                                </Button>
                            )}
                            {mode === "singlecategory" && (
                                <Button
                                    icon={<EditOutlined />}
                                    onClick={() => {
                                        dispatch(setCurrentSelectedMode(mode))
                                        dispatch(setQuickReportTypeToAdd("add"));
                                        setshowQuickReport(true);
                                    }}
                                    disabled={reportIsLoading || countryNotAvailable || scrapeViewer}
                                >
                                    Edit Library
                                </Button>
                            )}
                            {!["candidatewhitespaces",
                                "analysis_politicaltaxonomy",
                                "usersearchjourney",
                                "otherwhitespaces",
                                "claimswhitespaces",
                                "ingredientshitespaces",
                                "safetycocernsideeffectswhitespaces",
                                "macrowhitespaces",
                                "othermacrowhitespaces",
                                "standardtreatmentjourney",
                                "symptomswhitespaces",
                                "diagnosistreatmentwhitespaces"].includes(mode)
                                && moduleCode !== "facebookaudiences" && (
                                    <Button
                                        onClick={() => {
                                            dispatch(setCurrentSelectedMode("freeform"))
                                            dispatch(setFreeFormTypeToAdd("add"));
                                            setShowFreeForm(true);
                                        }}
                                        disabled={reportIsLoading || countryNotAvailable || scrapeViewer}
                                    >
                                        <div className="d-flex align-items-center">
                                            <RiFileCopy2Fill />
                                            <span>
                                                Add Free-form
                                            </span>
                                        </div>
                                    </Button>
                                )}
                            {(["candidatewhitespaces",
                                "analysis_politicaltaxonomy",
                                "usersearchjourney",
                                "otherwhitespaces",
                                "claimswhitespaces",
                                "ingredientshitespaces",
                                "safetycocernsideeffectswhitespaces",
                                "macrowhitespaces",
                                "othermacrowhitespaces",
                                "standardtreatmentjourney",
                                "symptomswhitespaces",
                                "diagnosistreatmentwhitespaces"].includes(mode) || (marketPackageCode === "whitespaces" && "mokb_analysis" === mode)) && (
                                    <Button
                                        onClick={() => {
                                            dispatch(setMarketCategoryTypeToAdd("new"));
                                            setShowWhitespacesSelection({
                                                show: true,
                                                isInclude: !mode.includes("other"),
                                                analysis: mode
                                            });
                                        }}
                                        disabled={reportIsLoading || countryNotAvailable || scrapeViewer}
                                    >
                                        Update Report
                                    </Button>
                                )}
                            <Dropdown menu={actionItems} disabled={reportIsLoading || scrapeViewer}>
                                <Button type="primary">
                                    Action
                                    <DownOutlined />
                                </Button>
                            </Dropdown>
                        </>
                    )}
                </div>
            </div>
        );
    };
    return getHeader();
}
export default ReportBuilderResultHeader;
